var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('DataListStateful',{attrs:{"title":"Черновики поставок","resource":"shipping-drafts","store":"shippingDrafts","columns":_vm.columns,"row-to":"shipping-new-steps","allow-delete":true,"filter-options":_vm.filter,"add-route":{ name: 'shipping-new-steps' }}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }